import {
  materialRenderers,
  materialCells,
} from '@jsonforms/material-renderers';

import { CurrencyControl } from './renderers/CurrencyControl';
import { PhoneControl } from './renderers/PhoneControl';
import { DateControl } from './renderers/DateControl';
import { SectionLabelRenderer } from './renderers/SectionLabelRenderer';
import { CardArrayRenderer } from './renderers/CardArrayRenderer';
import {
  currencyTester,
  phoneTester,
  dateTester,
  sectionLabelTester,
  cardArrayTester,
} from './testers';

export const urbanmixRenderers = [
  ...materialRenderers,
  { tester: currencyTester, renderer: CurrencyControl },
  { tester: phoneTester, renderer: PhoneControl },
  { tester: dateTester, renderer: DateControl },
  { tester: sectionLabelTester, renderer: SectionLabelRenderer },
  { tester: cardArrayTester, renderer: CardArrayRenderer },
];

export { materialCells };
export { validateAndEnrich } from './validation';
